<template lang="pug">
div(class="p-4 mb-5 bg-gray-lighter")
    div(v-if="pData.guarantee")
        div(
            v-html="pData.guarantee.title"
            class="or-spec-sheet-title text-white bg-primary flex justify-center font-bold -m-4 mb-5 p-3 sm:text-xl"
        )
        div(
            v-for="(item, index) in pData.guarantee.items"
            class="relative flex items-center font-bold mb-5"
        )
            span(class="flex justify-center items-center mr-3" style="width: 45px;height:24px;")
                shippingIcon(
                    v-if="item.graphicType == 'BOX'"
                    class="w-3/4 h-auto text-gray-darker fill-current"
                )
                img(
                    v-if="item.graphicType == 'THIRTY'"
                    src="@/assets/guarantee/calendar30.svg"
                    alt="calendar"
                    class="w-3/4 h-auto text-gray-darker fill-current"
                    loading="lazy"
                )
                img(
                    v-if="item.graphicType == 'WRENCH'"
                    src="@/assets/guarantee/installHelp.svg"
                    alt="tools"
                    class="h-auto text-gray-darker fill-current"
                    loading="lazy"
                    style="width: 65%;"
                )
                img(
                    v-if="item.graphicType == 'THUMB_UP'"
                    src="@/assets/guarantee/thumbsUp.svg"
                    alt="thumbs up"
                    class="h-auto text-gray-darker fill-current"
                    loading="lazy"
                    style="width: 65%;"
                )
                phoneIcon(
                    v-if="item.graphicType == 'PHONE'"
                    class="h-auto text-gray-darker fill-current"
                    style="width: 65%;"
                )
                img(
                    v-if="item.graphicType == 'DOLLAR'"
                    src="@/assets/guarantee/dollarCoin.svg"
                    alt="coin"
                    class="h-auto text-gray-darker fill-current"
                    loading="lazy"
                    style="width: 65%;"
                )
            Tooltip(:text="item.toolTip" :isFullWidth="true")
                span(class="cursor-pointer")
                    span(v-html="item.text")
                    infoIcon(class="inline-block text-info fill-current ml-1 w-4 h-4")

    div(
        v-if="pData.specSheet"
        class="mt-10"
    )
        div(class="text-xl text-black mt-4 mb-6 leading-none") Spec Sheet
        table(class="table-auto mx-0")
            tbody
                tr(v-for="spec in pData.specSheet" class="border-t")
                    td(v-html="spec.key" class="p-1 border-none whitespace-nowrap uppercase font-bold text-sm")
                    td(v-html="spec.value" class="p-1 border-none w-full")

    div(
        v-if="pData.inTheBox"
        class="mt-10"
    )
        div(class="text-xl text-black mt-4 mb-6 leading-none") What's In The Box
        ul(class="m-0 list-inside text-sm font-bold")
            li(v-for="item in pData.inTheBox")
                span(v-html="item")
</template>

<script>
import infoIcon from '@/assets/common/info?inline'
import Tooltip from '@/components/tooltip'
const phoneIcon = () => import(/* webpackChunkName: "phone-icon" */ '@/assets/common/phone?inline')
const shippingIcon = () =>
    import(/* webpackChunkName: "shipping-icon" */ '@/assets/common/shippingTruck?inline')

export default {
    name: 'SpecSheet',
    components: {
        shippingIcon,
        infoIcon,
        phoneIcon,
        Tooltip,
    },
    data() {
        return {
            showToolTip: false,
            currentTip: null,
        }
    },
    computed: {
        pData() {
            return this.$store.state.product.data
        },
    },
    methods: {
        toggleToolTip(index) {
            if (this.currentTip === index) {
                this.closeToolTip()
            } else {
                this.currentTip = index
                this.showToolTip = true
            }
        },
        closeToolTip() {
            this.currentTip = null
            this.showToolTip = false
        },
    },
}
</script>
